//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

const getUniversalDraftsState = (state: ICuralateStore) =>
  state.universalSchedule.universalDrafts;

export const getCurrentSearchOffset = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.searchOffset,
);

export const getIsFetchingDraftPosts = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.flags.isFetchingDraftPosts,
);

export const getIsFetchingAdditionalDraftPosts = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.flags.isFetchingAdditionalDraftPosts,
);

export const getHasReachedEndOfDraftPosts = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.flags.hasReachedEndOfDraftPosts,
);

export const getDraftPosts = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.draftPosts,
);

export const getDraftPostsTotalCount = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.totalCount,
);

export const getDraftSortBy = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.sortBy,
);

export const getHasDraftPosts = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.draftPosts.orderedIds.length > 0,
);

export const getIsDeleteDraftModalOpen = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.deleteDraftModal.isOpen,
);

export const getCurrentDeleteDraftModalDraftIds = createSelector(
  getUniversalDraftsState,
  (draftsState) => draftsState.deleteDraftModal.currentDraftIds,
);
